import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";

const Hero = () => {
  const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);

  const campaignSlides = [
    {
      id: 1,
      image: "https://images.unsplash.com/photo-1532629345422-7515f3d16bb6?q=80&w=2070&auto=format&fit=crop",
      category: "Medical",
      categoryColor: "from-rose-500 to-red-500",
      title: "Help little Aanya beat cancer",
      donor: {
        name: "Neha Gupta",
        action: "just donated ₹5,000",
        image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=64&h=64&fit=crop&crop=face"
      }
    },
    {
      id: 2,
      image: "https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?q=80&w=2070&auto=format&fit=crop",
      category: "Education",
      categoryColor: "from-blue-500 to-indigo-500",
      title: "Sponsor Ravi's engineering dream",
      donor: {
        name: "Arun Kumar",
        action: "just donated ₹2,500",
        image: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=64&h=64&fit=crop&crop=face"
      }
    },
    {
      id: 3,
      image: "https://images.unsplash.com/photo-1594708767771-a7502209ff51?q=80&w=2070&auto=format&fit=crop",
      category: "Education",
      categoryColor: "from-blue-500 to-indigo-500",
      title: "Help Meera get her school supplies",
      donor: {
        name: "Priya Sharma",
        action: "just donated ₹1,000",
        image: "https://images.unsplash.com/photo-1494790108755-2714420cc6d5?w=64&h=64&fit=crop&crop=face"
      }
    },
    {
      id: 5,
      image: "https://images.unsplash.com/photo-1469571486292-0ba58a3f068b?q=80&w=2070&auto=format&fit=crop",
      category: "Emergency",
      categoryColor: "from-amber-500 to-orange-500",
      title: "Flood relief for Chennai families",
      donor: {
        name: "Rahul Kapoor",
        action: "just donated ₹3,000",
        image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=64&h=64&fit=crop&crop=face"
      }
    },
    {
      id: 6,
      image: "https://images.unsplash.com/photo-1544027993-37dbfe44362b?q=80&w=2070&auto=format&fit=crop",
      category: "Medical",
      categoryColor: "from-rose-500 to-red-500",
      title: "Support Vikram's heart surgery",
      donor: {
        name: "Sneha Reddy",
        action: "just donated ₹4,000",
        image: "https://images.unsplash.com/photo-1517841905240-472988babdf9?w=64&h=64&fit=crop&crop=face"
      }
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % campaignSlides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const handleStartFundraiser = () => {
    localStorage.removeItem("preselectedPurpose");
    navigate("/start-fundraiser");
  };

  return (
    <section className="relative bg-white h-screen max-h-[900px] min-h-[750px] overflow-hidden">
      {/* Clean white background */}
      <div className="absolute inset-0 bg-gradient-to-b from-white via-white to-teal-50/20"></div>
      
      {/* Main content */}
      <div className="relative h-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col justify-between py-6">
        
        {/* TOP SECTION - Reordered for mobile: Carousel first, Content below */}
        <div className="grid lg:grid-cols-12 gap-6 lg:gap-8 items-center flex-1">
          
          {/* CAROUSEL - Show first on mobile, right column on desktop */}
          <div className="lg:col-span-6 lg:order-last mt-0 lg:mt-0">
            <div className="w-full">
              {/* CAROUSEL - WIDER (full width) + SHORTER (16:9 aspect ratio) */}
              <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-[16/9] w-full max-h-[380px]">
                
                {/* Slides */}
                {campaignSlides.map((slide, index) => (
                  <div
                    key={slide.id}
                    className={`absolute inset-0 transition-all duration-1000 ease-in-out ${
                      index === currentSlide 
                        ? 'opacity-100 scale-100' 
                        : 'opacity-0 scale-110'
                    }`}
                  >
                    <img 
                      src={slide.image}
                      alt={slide.title}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 via-gray-900/30 to-transparent"></div>
                    
                    {/* Category badge */}
                    <div className="absolute top-4 left-4">
                      <span className={`px-3 py-1.5 bg-gradient-to-r ${slide.categoryColor} text-white rounded-full text-xs font-semibold shadow-lg`}>
                        {slide.category}
                      </span>
                    </div>

                    {/* Campaign content - compact for shorter height */}
                    <div className="absolute bottom-0 left-0 right-0 p-4 text-white">
                      <h3 className="text-lg md:text-xl font-bold mb-2 leading-tight line-clamp-1">
                        {slide.title}
                      </h3>

                      {/* Live donation notification - compact */}
                      <div className="flex items-center justify-between bg-white/10 backdrop-blur-sm rounded-lg p-2.5 border border-white/20">
                        <div className="flex items-center gap-2">
                          <img 
                            src={slide.donor.image}
                            alt={slide.donor.name}
                            className="w-7 h-7 rounded-full border-2 border-white"
                          />
                          <div>
                            <p className="text-xs font-medium">{slide.donor.name}</p>
                            <p className="text-xs text-white/90">{slide.donor.action}</p>
                          </div>
                        </div>
                        <span className="flex items-center gap-1 text-[10px] bg-white/20 px-2 py-1 rounded-full">
                          <span className="w-1 h-1 bg-emerald-400 rounded-full animate-pulse"></span>
                          LIVE
                        </span>
                      </div>
                    </div>
                  </div>
                ))}

                {/* Progress indicators - dots */}
                <div className="absolute bottom-3 right-3 flex items-center gap-1.5">
                  {campaignSlides.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => setCurrentSlide(index)}
                      className={`transition-all duration-300 ${
                        index === currentSlide
                          ? 'w-6 h-1.5 bg-white rounded-full shadow-lg'
                          : 'w-1.5 h-1.5 bg-white/50 hover:bg-white/80 rounded-full'
                      }`}
                    />
                  ))}
                </div>

                {/* Slide counter */}
                <div className="absolute bottom-3 left-3 bg-black/30 backdrop-blur-sm px-2 py-1 rounded-md text-white text-[10px]">
                  {currentSlide + 1} / {campaignSlides.length}
                </div>
              </div>
            </div>
          </div>

          {/* LEFT COLUMN - Content - Show second on mobile, left column on desktop */}
          <div className="lg:col-span-6 space-y-5">
            {/* Trust badge */}
            <div className="inline-flex items-center gap-2 bg-white px-4 py-2 rounded-full shadow-md border border-gray-100">
              <span className="text-sm font-medium text-gray-700">
                World's most loved fundraising platform
              </span>
            </div>

            {/* Headline */}
            <h1 className="text-4xl md:text-5xl lg:text-5xl xl:text-6xl font-bold text-gray-900 tracking-tight leading-tight">
              Start a fundraiser.
              <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-600 to-emerald-600">
                It's free, it's easy, it matters.
              </span>
            </h1>

            {/* Subheadline */}
            <p className="text-lg text-gray-600 leading-relaxed max-w-lg">
              In 2 minutes, you can start raising money for yourself, 
              someone you love, or a cause you believe in.
            </p>

            {/* CTA buttons */}
            <div className="flex flex-wrap items-center gap-3 pt-2">
              <button
                onClick={handleStartFundraiser}
                className="px-6 py-3 bg-gradient-to-r from-teal-600 to-emerald-600 text-white rounded-xl font-semibold text-base hover:shadow-xl transition-all transform hover:scale-105 w-full sm:w-auto"
              >
                Start your fundraiser →
              </button>
            </div>
          </div>
        </div>

        {/* BOTTOM SECTION - CATEGORIES - Clean card */}
        <div className="w-full mt-4 lg:mt-4">
          <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-5">
            {/* Header */}
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-2">
                <div className="w-7 h-7 bg-gradient-to-r from-teal-500 to-emerald-500 rounded-lg flex items-center justify-center">
                  <svg className="w-3.5 h-3.5 text-white" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM11 13a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
                  </svg>
                </div>
                <h3 className="font-semibold text-gray-800">Browse by category</h3>
              </div>
              <button className="text-xs text-teal-600 font-medium hover:text-teal-700 flex items-center gap-1">
                View all
                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </button>
            </div>
            
            {/* Category Icons - Clean Grid */}
            <div className="grid grid-cols-3 sm:grid-cols-6 gap-2">
              {[
                { name: 'Medical', icon: '🏥', color: 'from-rose-500 to-red-500' },
                { name: 'Education', icon: '📚', color: 'from-blue-500 to-indigo-500' },
                { name: 'Emergency', icon: '⚡', color: 'from-amber-500 to-orange-500' },
                { name: 'Animals', icon: '🐾', color: 'from-teal-500 to-emerald-500' },
                { name: 'Community', icon: '👥', color: 'from-purple-500 to-pink-500' },
                { name: 'Creative', icon: '🎨', color: 'from-sky-500 to-cyan-500' },
              ].map((cat) => (
                <button 
                  key={cat.name}
                  className="flex flex-col items-center p-2 rounded-lg hover:bg-gray-50 transition-all group"
                >
                  <div className={`w-10 h-10 flex items-center justify-center text-xl bg-gradient-to-br ${cat.color} rounded-lg text-white shadow-sm mb-1 group-hover:scale-110 transition-transform`}>
                    {cat.icon}
                  </div>
                  <span className="text-xs font-medium text-gray-700">{cat.name}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;